import { RootState } from './types';

export const selectSideMenuModalState = (state: RootState) =>
  state.sideMenuModal;
export const selectPromotionModalViewState = (state: RootState) =>
  state.promotionModalView;
export const selectRestoreAlertModalState = (state: RootState) =>
  state.restoreAlertModal;
export const selectSuccessPromotionModalViewState = (state: RootState) =>
  state.successPromotionModalView;
export const selectFailurePaymentModalViewState = (state: RootState) =>
  state.failurePaymentModalView;
export const selectShouldRefetchModalData = (state: RootState) =>
  state.refetchModalData;
export const selectItemsBalanceModalViewState = (state: RootState) =>
  state.itemsBalanceModalView;
export const selectBuyItemsModalViewState = (state: RootState) =>
  state.buyItemsModalView;
export const selectWalletPayModalViewState = (state: RootState) =>
  state.walletPayModalView;
export const selectTerminalModalViewState = (state: RootState) =>
  state.terminalModalView;
export const selectPersonalAccountModalViewState = (state: RootState) =>
  state.personalAccountModalView;
export const selectProfilePromotionItemId = (state: RootState) =>
  state.profilePromotionItemId;
export const selectProfileEditSuccessMessage = (state: RootState) =>
  state.profileEditSuccessMessage;
export const selectProfilePromotionItemsModal = (state: RootState) =>
  state.profilePromotionItemsModalView;
export const selectPackagePayModalViewState = (state: RootState) =>
  state.packagePayModalView;
export const selectSuccessWebviewPaymentStatusModalViewState = (
  state: RootState
) => state.successWebViewPaymentStatusModalView;
export const selectFailureWebViewPaymentStatusModalViewState = (
  state: RootState
) => state.failureWebViewPaymentStatusModalView;
export const selectAuthEmail = (state: RootState) => state.authModal.email;
export const selectNotification = (state: RootState) => state.notification;
export const selectSearchLocationNames = (state: RootState) =>
  state.searchForm.chosenLocationNames;
export const selectSearchFormCurrentCity = (state: RootState) =>
  state.searchForm.currentCity;
export const selectSearchFormCurrentState = (state: RootState) =>
  state.searchForm.currentState;
export const selectSearchFormResetButtonIsDisabled = (state: RootState) =>
  state.searchForm.resetButtonIsDisabled;
export const selectSearchFormLocationResetButtonIsDisabled = (
  state: RootState
) => state.searchForm.locationsResetButtonIsDisabled;
export const selectSearchFormCurrentSortType = (state: RootState) =>
  state.searchForm.currentSortType;
export const selectSearchFormLocationIds = (state: RootState) =>
  state.searchForm.locationIds;
export const selectSearchFormIsLoadingResultByNumber = (state: RootState) =>
  state.searchForm.isLoadingResultByNumber;
export const selectSearchFormResultByNumber = (state: RootState) =>
  state.searchForm.resultByNumber;
export const selectAdriverSelectedCity = (state: RootState) =>
  state.adriverBanner.selectedCityName;
export const selectUserCards = (state: RootState) => state.userCards.cardsList;
export const selectAddNewItemModalResetButtonIsDisabled = (state: RootState) =>
  state.addNewItemModal.creationResetButtonIsDisabled;
export const selectAddNewItemModalIsOpenAuthWindow = (state: RootState) =>
  state.addNewItemModal.isOpenAuthWindow;
export const selectIsBannedUsed = (state: RootState) =>
  state.addNewItemModal.isBannedUser;
export const selectCurrentItemAuthModalOpen = (state: RootState) =>
  state.currentItem.isAuthModalOpen;
export const selectCurrentItem = (state: RootState) =>
  state.currentItem.currentItem;
export const selectProfileTransfersModalVisible = (state: RootState) =>
  state.profile.isTransferModalVisible;
export const selectReplenishmentNotificationsModalIsVisible = (
  state: RootState
) => state.replenishmentNotificationsModal.isVisible;
export const selectReplenishmentNotifications = (state: RootState) =>
  state.replenishmentNotifications;
export const selectProfileMenuModalIsVisible = (state: RootState) =>
  state.profile.profileMenuModalIsVisible;
export const selectModalLocks = (state: RootState) =>
  state.modalLock.activeLocks;
